import { render } from "./RolesEditorProjectsSite.vue?vue&type=template&id=8fe37f0e&scoped=true"
import script from "./RolesEditorProjectsSite.vue?vue&type=script&lang=js"
export * from "./RolesEditorProjectsSite.vue?vue&type=script&lang=js"

import "./RolesEditorProjectsSite.vue?vue&type=style&index=0&id=8fe37f0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe37f0e"]])

export default __exports__